import React, { useState, useEffect } from 'react'

import { Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import EditFormListChoiceWidget from '../dynamicForm/EditFormListChoiceWidget'
import HTMLWidget from '../../HTMLWidget'
import CustomAlertMessage from '../../CustomAlertMessage'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import ViewFormListChoiceWidget from '../dynamicForm/ViewFormListChoiceWidget'
import { saveFormProjectFeature } from '../../../redux/actions/subProjectProposal'
import { setAlertMessage } from '../../../utils/messageUtil'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'

export default function ProjectFeatureWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [notiMsg, setNotiMsg] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormProjectFeature(subProjectId, request)
      if (response) {
        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      // console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('onSubmit data : ', data)

    let values = createReq(formSchema.objects, data)

    let req = {
      id: subProjectId,
      values: values,
    }

    // console.log('req : ', JSON.stringify(req))

    handleSave(req)
  }

  const createReq = (objects, data) => {
    let values = []

    objects?.forEach((item) => {
      if (item.type == 'RADIO') {
        let val = data[`${item.name}`]

        values.push({
          refId: item.name,
          value: val,
        })

        if (item.childs?.length > 0) {
          let result = createReq(item.childs, data)
          console.log('item.childs : ', result)

          values = [...values, ...result]
        }

        item.inputOptions?.forEach((ip) => {
          if (val == ip.id) {
            ip.moreInputs?.forEach((mp) => {
              values.push({
                refId: mp.name,
                value: data[`${mp.name}`],
              })
            })
          }
        })
      } else {
        values.push({
          refId: item.name,
          value: data[`${item.name}`],
        })

        if (item.childs?.length > 0) {
          let result = createReq(item.childs, data)
          console.log('item.childs : ', result)

          values = [...values, ...result]
        }

        item.inputOptions?.forEach((ip) => {
          if (val == ip.id) {
            ip.moreInputs?.forEach((mp) => {
              values.push({
                refId: mp.name,
                value: data[`${mp.name}`],
              })
            })
          }
        })
      }
    })
    return values
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}
      <div style={{ marginTop: -10 }}>
        {isEdit && showCommandButton ? (
          <>
            {formSchema.description && (
              <Row style={{ marginBottom: 10 }}>
                <CustomAlertMessage contents={formSchema.description} />
              </Row>
            )}

            <EditFormListChoiceWidget
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              setLoading={setIsLoading}
              ignoreDesc
            />
          </>
        ) : (
          <ViewFormListChoiceWidget schema={formSchema} />
        )}

        {formSchema.note && (
          <Message
            showIcon
            type="info"
            style={{ marginTop: 20 }}
            description={<HTMLWidget data={formSchema.note} />}
          />
        )}
      </div>

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
